(function () {
  'use strict';

  var sections = document.querySelectorAll('[data-scroll-text-reveal]');
  if (!sections.length) return;

  var rafId = null;

  function setup(section) {
    var scrollLength = parseInt(section.getAttribute('data-scroll-length'), 10) || 200;
    section.style.height = scrollLength + 'vh';
    section._strWords = section.querySelectorAll('[data-str-word]');
  }

  function update(section) {
    var words = section._strWords;
    if (!words || !words.length) return;

    var rect = section.getBoundingClientRect();
    var viewportHeight = window.innerHeight;
    var scrollableDistance = section.offsetHeight - viewportHeight;
    var progress;

    if (scrollableDistance <= 0) {
      progress = rect.top <= 0 ? 1 : 0;
    } else {
      progress = -rect.top / scrollableDistance;
    }
    progress = Math.max(0, Math.min(1, progress));

    var total = words.length;
    words.forEach(function (word, index) {
      var wordThreshold = (index + 0.5) / total;
      if (progress >= wordThreshold) {
        word.classList.add('is-active');
      } else {
        word.classList.remove('is-active');
      }
    });
  }

  function loop() {
    sections.forEach(update);
    rafId = window.requestAnimationFrame(loop);
  }

  function onResize() {
    sections.forEach(setup);
  }

  sections.forEach(setup);
  loop();

  window.addEventListener('resize', onResize);
})();